import { individualApi } from '@/apis';

export default {
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {String} individualId
   */
  async initRiskAssign({ commit, dispatch }, individualId) {
    commit('reset');
    commit('setLoading', true);
    const requests = [
      dispatch('fetchDetail', individualId),
      dispatch('fetchQuestionnaire', individualId),
    ];
    await Promise.all(requests);
    commit('setLoading', false);
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchDetail({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestDetail(token, individualId);
      commit('setDetail', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} individualId
   */
  async fetchQuestionnaire({ commit, rootGetters }, individualId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestCurrentQuestionnaire({
        token,
        individualId,
      });
      commit('setQuestionnaire', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} questionnaireId
   */
  async refreshQuestionnaire({ commit, rootGetters }, questionnaireId) {
    const token = rootGetters['auth/token'];
    try {
      const response = await individualApi.requestQuestionnaireDetail({
        token,
        questionnaireId,
      });
      commit('setQuestionnaire', response.data);
    }
    catch (error) {
      commit('setError', error);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Function} dispatch
   * @param {Object} rootGetters
   * @param {String} questionId
   * @param {String} questionnaireId
   * @param {Number} risk
   */
  async assignRiskToQuestion(
    { commit, dispatch, rootGetters },
    { questionId, questionnaireId, risk },
  ) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestQuestionAssignrisk({
        token,
        questionId,
        risk,
      });
      await dispatch('refreshQuestionnaire', questionnaireId);
    }
    catch (error) {
      commit('setError', error);
    }
    finally {
      commit('setHandling', false);
    }
  },
  /**
   *
   * @param {Function} commit
   * @param {Object} rootGetters
   * @param {String} questionnaireId
   */
  async assignRisk({ commit, rootGetters }, questionnaireId) {
    const token = rootGetters['auth/token'];
    commit('setHandling', true);
    try {
      await individualApi.requestAssignrisk({
        token,
        questionnaireId,
      });
      return true;
    }
    catch (error) {
      commit('setError', error);
      return false;
    }
    finally {
      commit('setHandling', false);
    }
  },
};
